const Tooltip = ({
	icon,
	title,
	message,
	containerStyle,
	tooltipStyle,
	position = 'right',
}: {
	icon?: string;
	title?: string;
	message: string;
	containerStyle?: string;
	tooltipStyle?: string;
	position: 'top' | 'bottom' | 'left' | 'right';
}) => {
	const positionClasses = {
		top: 'bottom-full left-[50%] -translate-x-[50%]',
		bottom: 'top-full left-[50%] -translate-x-[50%]',
		left: 'right-full top-[50%] -translate-y-[30%]',
		right: 'left-full top-[50%] -translate-y-[30%]',
	};

	const tipPositionClasses = {
		top: 'border-t-8 border-r-8 border-l-8 border-r-transparent border-l-transparent mt-2',
		bottom: 'border-b-8 border-r-8 border-l-8 border-r-transparent border-l-transparent mb-2',
		left: 'border-l-8 border-t-8 border-b-8 border-t-transparent border-b-transparent',
		right: 'border-r-8 border-t-8 border-b-8 border-t-transparent border-b-transparent',
	};

	const positionMargin = {
		top: 'mb-2 ',
		bottom: 'mt-2',
		left: 'mr-2',
		right: 'ml-2',
	};

	return (
		<div
			className={`group relative w-max ${containerStyle ? containerStyle : ''}`}
		>
			<div className="cursor-pointer">
				<img src={icon} />
			</div>
			<span
				className={`absolute hidden opacity-0 group-hover:block group-hover:opacity-100
            transition-opacity duration-300 border-rcrm-secondary-grey ${positionClasses[position]} ${tipPositionClasses[position]}`}
			></span>
			<span
				className={`absolute z-[60] hidden opacity-0 ${positionClasses[position]} ${positionMargin[position]} transform:none 
            w-[180px] px-3 py-2 text-sm rounded-lg bg-rcrm-secondary-grey
            group-hover:block group-hover:opacity-100 transition-opacity duration-300 overflow-auto ${tooltipStyle ? tooltipStyle : ''}`}
			>
				{message}
			</span>
		</div>
	);
};

export default Tooltip;
